import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetDailyKmAndFuelReportListPagingAndFilterRequest {
    searchTerm: string,
    skip: number
    take: number
    startDate: string
    endDate: string
    selectedDevices: CustomMultiSelectModel[]
    columnChooser: ColumnChooserModel[] | undefined,
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetDailyKmAndFuelReportListPagingAndFilterRequest: GetDailyKmAndFuelReportListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    selectedDevices: [],
    columnFilters: []
}